var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 6V1.33333C18.6667 0.6 18.0667 0 17.3333 0H1.33333C0.6 0 0 0.6 0 1.33333V14.6667C0 15.4 0.6 16 1.33333 16H17.3333C18.0667 16 18.6667 15.4 18.6667 14.6667V10L24 15.3333V0.666667L18.6667 6Z",
    fill: "#004BA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCam);
export default __webpack_public_path__ + "static/media/iconCam.e80a5eb4984945bd72f0528c30c8ee60.svg";
export { ForwardRef as ReactComponent };